import Money from "components/base/InputMoney";
import Scrollbar from "components/base/Scrollbar";
import {
  AlterarDepartamentoDtoType,
  CriarDepartamentoDtoType,
} from "data/departamentos";
import { EmpresaType } from "data/empresa";
import { floatFormat } from "helpers/utils";
import { ChangeEvent } from "react";
import { Form, Table } from "react-bootstrap";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import { useEmpresas } from "providers/EmpresaProvider";

interface DepartamentoEmpresaTableProps {}

const DepartamentoEmpresaTable = ({}: DepartamentoEmpresaTableProps) => {
  const { empresas, isLoading } = useEmpresas();

  const { control } = useFormContext<
    CriarDepartamentoDtoType | AlterarDepartamentoDtoType
  >();

  const { fields, append } = useFieldArray({
    control,
    name: "empresas",
    rules: { required: true },
  });

  console.log("Debug - empresas:", empresas?.map(e => ({ id: e.id, nome: e.nomeFantasia })));
  console.log("Debug - fields:", fields);

  return (
    <Scrollbar autoHeight autoHeightMax="100%" className="table-scrollbar">
      <Table className="phoenix-table fs-9 mb-0 border-top border-translucent">
        <thead>
          <tr>
            <th scope="col">Empresa</th>
            <th className="text-center" scope="col" style={{ width: "20%" }}>
              Desconto
            </th>
          </tr>
        </thead>
        {!isLoading && empresas && empresas.length > 0 && (
          <tbody className="list" id="cart-table-body">
            {empresas.map((empresa) => {
              const fieldIndex = fields.findIndex(field => 
                field.empresaId == empresa.id // Usando == para comparar number/string
              );
              const hasField = fieldIndex >= 0;
              
              console.log(`Empresa ${empresa.nomeFantasia} (ID: ${empresa.id}):`, {
                fieldIndex,
                hasField,
                fieldsForThisEmpresa: fields.filter(f => f.empresaId == empresa.id)
              });
              
              return (
                <DepartamentoEmpresaRow
                  key={`${empresa.id}-${fieldIndex}-${hasField}`}
                  index={fieldIndex}
                  empresa={empresa}
                  hasField={hasField}
                  onCreateField={() => {
                    // Verificar novamente se o campo já existe antes de criar
                    const currentFieldExists = fields.some(field => field.empresaId == empresa.id);
                    if (!currentFieldExists) {
                      append({
                        empresaId: empresa.id,
                        desconto: 0,
                      });
                    }
                  }}
                />
              );
            })}
          </tbody>
        )}
      </Table>
    </Scrollbar>
  );
};

const DepartamentoEmpresaRow = ({
  empresa: { nomeFantasia, id },
  index,
  hasField,
  onCreateField,
}: {
  empresa: EmpresaType;
  index: number;
  hasField: boolean;
  onCreateField: () => void;
}) => {
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useFormContext<CriarDepartamentoDtoType | AlterarDepartamentoDtoType>();

  return (
    <tr className="cart-table-row">
      <td>
        <Link className="fw-semibold line-clamp-2" to="#!">
          {nomeFantasia}
        </Link>
      </td>
      {hasField && (
        <>
          <input
            type="hidden"
            {...register(`empresas.${index}.empresaId`, {
              required: "Campo obrigatório",
            })}
            value={id}
          />
          <Form.Group
            as="td"
            className="text-center"
            controlId={`empresas.${index}.desconto`}
          >
            <Controller
              name={`empresas.${index}.desconto`}
              control={control}
              render={({ field }) => {
                console.log(`Campo empresas.${index}.desconto - Empresa ${id}:`, {
                  fieldValue: field.value,
                  fieldName: field.name,
                  index,
                  empresaId: id
                });
                
                return (
                  <Money
                    {...field}
                    isInvalid={!!errors?.empresas?.[index]?.desconto}
                  />
                );
              }}
            />
            <Form.Control.Feedback type="invalid">
              {errors?.empresas?.[index]?.desconto?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}
      {!hasField && (
        <Form.Group
          as="td"
          className="text-center"
        >
          <Money
            value={0}
            onChange={(value: number) => {
              // Quando o usuário começar a editar, criar o campo
              onCreateField();
            }}
          />
        </Form.Group>
      )}
    </tr>
  );
};

export default DepartamentoEmpresaTable;
